import { useEffect, useState } from "react";

export const readDeviceVideoOrientation = () => {
  if (typeof window === "undefined") return "portrait";
  if (window.matchMedia) {
    return window.matchMedia("(orientation: landscape)").matches ? "landscape" : "portrait";
  }
  return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
};

export const subscribeDeviceVideoOrientation = (onChange) => {
  const media = window.matchMedia?.("(orientation: landscape)");
  const update = () => onChange(readDeviceVideoOrientation());

  media?.addEventListener?.("change", update);
  window.screen?.orientation?.addEventListener?.("change", update);
  window.addEventListener("orientationchange", update);
  window.addEventListener("resize", update);
  window.visualViewport?.addEventListener?.("resize", update);

  return () => {
    media?.removeEventListener?.("change", update);
    window.screen?.orientation?.removeEventListener?.("change", update);
    window.removeEventListener("orientationchange", update);
    window.removeEventListener("resize", update);
    window.visualViewport?.removeEventListener?.("resize", update);
  };
};

const useDeviceVideoOrientation = (lockedOrientation = null) => {
  const [orientation, setOrientation] = useState(readDeviceVideoOrientation);
  const locked = lockedOrientation === "landscape" || lockedOrientation === "portrait"
    ? lockedOrientation
    : null;

  useEffect(() => {
    if (locked) return undefined;

    let frame = null;
    const unsubscribe = subscribeDeviceVideoOrientation((nextOrientation) => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => setOrientation(nextOrientation));
    });
    setOrientation(readDeviceVideoOrientation());

    return () => {
      window.cancelAnimationFrame(frame);
      unsubscribe();
    };
  }, [locked]);

  return locked || orientation;
};

export default useDeviceVideoOrientation;
